import { Icon } from '@helpers/icons';
import SvgLogoWhite from '@img/logo-all-white.svg';
import SvgLogo from '@img/logo.svg';
import Button, { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
import S from './Header.styles';
import MobileNavigation from './MobileNavigation/MobileNavigation';
const Header = (props) => {
    const [hasScrolled, setHasScrolled] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleScroll = () => {
        const position = window.scrollY;
        position > 0 ? setHasScrolled(true) : setHasScrolled(false);
    };
    React.useEffect(() => {
        handleScroll();
    }, []);
    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hasScrolled]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, { "data-solid": props.variant === 'solid' || hasScrolled || open, onMouseEnter: () => setHasScrolled(true), onFocusCapture: () => setHasScrolled(true), onMouseLeave: handleScroll, onBlur: handleScroll },
            React.createElement(S.Inner, null,
                React.createElement(S.Logo, { href: "/", title: props.translations?.['global.home'] ?? 'Home' },
                    React.createElement(SvgLogo, null),
                    React.createElement(SvgLogoWhite, null)),
                React.createElement(DesktopNavigation, { email: props.email, items: props.navigationItems, socialLinks: props.socialLinks, telephone: props.telephone, translations: props.translations }),
                React.createElement(S.CtaLinks, null,
                    props.cta1 && (React.createElement(React.Fragment, null,
                        React.createElement(LinkButton, { buttonType: "solid", href: props.cta1.url, target: props.cta1.target, icon: props.cta1.icon }, props.cta1.text),
                        React.createElement(LinkButton, { buttonType: "outline-black", href: props.cta1.url, target: props.cta1.target, icon: props.cta1.icon }, props.cta1.text))),
                    props.cta2 && (React.createElement(LinkButton, { buttonType: "solid", href: props.cta2.url, target: props.cta2.target, icon: props.cta2.icon }, props.cta2.text))),
                React.createElement(Button, { buttonType: "solid-white", icon: Icon.Menu, iconOnly: true, onClick: () => setOpen(!open) }, "Menu"))),
        React.createElement(S.Shadow, { "data-solid": props.variant === 'solid' || hasScrolled || open }),
        React.createElement(MobileNavigation, { email: props.email, items: props.navigationItems, onClose: () => setOpen(false), open: open, socialLinks: props.socialLinks, telephone: props.telephone, translations: props.translations })));
};
export default Header;
